import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Contributors
 * id 1F233821-5ED4-4CB3-8933-9A16C05D7AC9
 * name black-mesa
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/black-mesa.svg
 * tags
 * - Brand / Logo 
 * - Gaming / RPG 
 */
export const BlackMesaIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12C4,14.39 5.05,16.53 6.71,18H9V12H17L19.15,15.59C19.69,14.5 20,13.29 20,12A8,8 0 0,0 12,4Z" /></>, 'BlackMesaIcon');
export default BlackMesaIcon